import { clsx } from 'clsx'

import {
  Page,
  type PageProps,
} from '../../../flecto-modules-saas/src/application/components/Page/Page'
import { Close } from './Close'
import classes from './styles.module.css'

export type DrawerProps = PageProps & {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export function Drawer({ size = 'xl', children, ...props }: DrawerProps) {
  const drawerClasses = clsx(classes.drawer, classes[size])

  return (
    <Page className={drawerClasses} {...props}>
      {children}
    </Page>
  )
}

Drawer.Close = Close
Drawer.Actions = Page.Actions
Drawer.Title = Page.Title
Drawer.Content = Page.Content
Drawer.Sidebar = Page.Sidebar
Drawer.Description = Page.Description
